<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Partecipanti',
      link: '/partecipanti'
    }, {
      label: 'Gestisci Categorie'
    }]"
  />

  <form autocomplete="off">
    <div
      v-for="category in categories"
      :key="'company-category-' + category.uuid"
    >
      <InputBoolean
        v-model="form[category.uuid]"
        :error-fields="[]"
        :name="category.code"
        :submitted="false"
      >
        {{ category.code }}
      </InputBoolean>
    </div>
    <SubmitButtons
      mode="update"
      :pending="pending"
      :update="update"
    />
  </form>
</template>

<script setup>
import { reactive,ref } from 'vue'
import { useRouter } from 'vue-router';

import InputBoolean from '@/components/form/InputBoolean.vue';
import SubmitButtons from '@/components/form/SubmitButtons.vue';
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from '@/composables/axios';
import { useNotificationsStore } from '@/stores/notifications';

const props = defineProps({
  id: {
    required: true,
    type: String
  }
})

const axios = useAxios()
const notificationStore = useNotificationsStore()
const router = useRouter()

const pending = ref(false);

const categoriesResp = await axios.get('/category/list');
const categories = ref(categoriesResp.data)

const resp = await axios.get('/company/' + props.id);
const companyCategories = resp.data.categories

const form = reactive(categories.value.reduce((carry, category) => {
  carry[category.uuid] = companyCategories.includes(category.uuid)
  return carry;
}, {}))

const update = async () => {
  pending.value = true;
  try {
    await axios.post('/company/' + props.id + '/category', { uuids: Object.keys(form).filter((key) => form[key]) })

    notificationStore.pushSuccess('Partecipante aggiornato con successo');
    router.push('/partecipanti');
  } catch (e) {
    pending.value = false;
    throw e
  }
}

</script>